import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { EmailsQueryVariables } from '@/gql/graphql';
import type { PaginatedEmailTypeResponse } from '@/models/email';

export const fetchEmails = async ({
  query,
  type,
  status,
  start,
  end,
  pagination,
}: EmailsQueryVariables): Promise<PaginatedEmailTypeResponse> => {
  const response = await queryExecute({
    query: graphql(`
      query Emails($query: String, $type: String, $status: String, $start: String, $end: String, $pagination: PaginationInputType) {
        emails(query: $query, type: $type, status: $status, start: $start, end: $end, pagination: $pagination) {
          count
          rows {
            id
            userId
            fromEmail
            toEmail
            name
            subject
            messageId
            rideId
            scheduledRideId
            groceryId
            scheduledGroceryId
            deliveryOrderId
            status
            reason
            purpose
            openedAt
            createdAt
            updatedAt
          }
        }
      }
    `),
    variables: {
      query,
      type,
      status,
      start,
      end,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.emails;
};
